import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"trsc-view",domProps:{"innerHTML":_vm._s(_vm.html)}}),_c(VBtn,{staticClass:"copyBtn",attrs:{"dark":"","color":"primary"},on:{"click":function($event){return _vm.copyText()}}},[_vm._v("翻刻文をコピー")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }